import { LocalStorageRepository } from "./LocalStorageRepository";

import { TodoList } from "../../../../../types/types";
import { STORAGE_KEY_TODO_LISTS } from "../../../constants";

export class TodoListLocalRepository extends LocalStorageRepository<TodoList> {
    constructor() {
        super(STORAGE_KEY_TODO_LISTS);
    }

    findAllByWorkspaceId(workspaceId: string): TodoList[] {
        return this.findAll().filter(list => list.workspaceId === workspaceId);
    }
}
